import { render, staticRenderFns } from "./securitySetting.vue?vue&type=template&id=967f3f7e"
import script from "./securitySetting.vue?vue&type=script&lang=js"
export * from "./securitySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('967f3f7e')) {
      api.createRecord('967f3f7e', component.options)
    } else {
      api.reload('967f3f7e', component.options)
    }
    module.hot.accept("./securitySetting.vue?vue&type=template&id=967f3f7e", function () {
      api.rerender('967f3f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userSystem/setting/components/securitySetting.vue"
export default component.exports